function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1712",
    d: "M21 0A21 21 0 1 1 0 21 21 21 0 0 1 21 0z",
    style: {
      fill: "none",
      opacity: 0.998
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2075",
    d: "m54.666 14.018-5.742-3.324a2.625 2.625 0 0 0-3.6.484V7.77l.78.78A2.666 2.666 0 1 0 47.993 4h-2.665V2.667a2.667 2.667 0 1 0-5.333 0V4h-2.668a2.667 2.667 0 1 0 1.885 4.55l.783-.783V18l-.943-.944a5.323 5.323 0 0 0-6.6-.741.867.867 0 0 0-.172.136.968.968 0 0 0 0 1.372l8.978 8.98.007.007.148.148v-.012A8.623 8.623 0 0 0 55.994 20.7v-4.385a2.655 2.655 0 0 0-1.328-2.297zm-9.338-8.686h2.665a1.333 1.333 0 1 1-.943 2.276l-1.722-1.723zm-4-2.665a1.333 1.333 0 0 1 2.667 0V4h-2.667zm-3.059 4.941a1.333 1.333 0 1 1-.943-2.276h2.668v.551zM47.362 28a7.263 7.263 0 0 1-5.029-2.02l-8.773-8.76a4 4 0 0 1 4.549.78l1.743 1.743a.584.584 0 0 0 .62.133 1.317 1.317 0 0 0 .856-1.233V6.434L42.66 5.1l1.335 1.335v6.612a.666.666 0 0 0 1.183.421l1.184-1.451a1.293 1.293 0 0 1 1.787-.243l5.845 3.4a1.312 1.312 0 0 1 .668 1.139V20.7a7.306 7.306 0 0 1-7.3 7.3z",
    transform: "translate(-22.994 6)",
    style: {
      fill: "inherit"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminders);
export default __webpack_public_path__ + "static/media/reminders.6b0a2e39.svg";
export { ForwardRef as ReactComponent };